<template>
    <div>
        <Header v-if="getListObj" page-name="言語分析"></Header>
        <div class="container">
            <!-- Nav tabs -->
            <ul v-if="getListObj" class="nav nav-tabs tab-sticky breadcrumb p-0 mb-1 nav-justified" role="tablist">
                <li class="nav-item">
                    <a class="nav-link text-center px-2" data-toggle="tab" href="#lang_proj">
                        案件分析
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link active text-center px-2" data-toggle="tab" href="#lang_his">
                        検索履歴
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-center px-2" data-toggle="tab" href="#lang_total">
                        検索頻度
                    </a>
                </li>
            </ul>
             
            <div class="tab-content">
                <div id="lang_proj" class="container tab-pane fade p-0">
                    <div v-if="langList.length">
                        <!-- 案件分析 -->
                        <div class="card card-body mb-1 px-2">
                            <div class="let-space-1">
                                <span class=""> 合計: <b>{{getCmpLangGraph.all_cnt}}</b> </span>
                                <span class="pl-2"> 外国籍OK: <b>{{getCmpLangGraph.foreign_ok_cnt}}</b> </span>
                                <span class="pl-2"> リモートOK: <b>{{getCmpLangGraph.remote_ok_cnt}}</b> </span>
                            </div>
                        </div>
                        <div class="card mb-2 p-2">
                            <ul class="list-group list-group-flush">
                                <li v-for="item in langList" :key="item.lang" class="list-group-item p-0 let-space-1">
                                    <div class="d-flex justify-content-between">
                                        <span v-if="item.lang" class="text-truncate">
                                            <b>{{item.lang}}</b>：<small>{{item.lang_cnt}}/{{getCmpLangGraph.all_cnt}}/{{item.percent}}%</small>
                                        </span>
                                        <span v-else class="text-truncate">
                                            <small>
                                                <b>その他</b>：{{item.lang_cnt}}/{{getCmpLangGraph.all_cnt}}/{{item.percent}}%
                                            </small>
                                        </span>
                                        <span class="text-truncate pl-2">
                                            <small>
                                                外OK：{{item.foreign_ok}}/{{item.lang_cnt}}/{{item.percent_foreign}}%
                                            </small>
                                        </span>
                                        <span class="text-truncate pl-2">
                                            <small>
                                                遠OK:{{item.remote_ok}}/{{item.lang_cnt}} 
                                            </small>
                                        </span>
                                    </div>
                                    <div class="progress-bar" role="progressbar" :style="{width:item.percent + '%'}" :aria-valuenow="item.percent" aria-valuemin="0" aria-valuemax="100">
                                        {{item.percent}}%
                                        <div class="progress-bar bg-success" role="progressbar" :style="{width:item.percent_foreign + '%'}" :aria-valuenow="item.percent_foreign" aria-valuemin="0" aria-valuemax="100">
                                            <small> {{item.percent_foreign}}% </small>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-else class="py-5 text-center text-muted">
                        <i class="fas fa-search h1"></i><br>
                        データが見つかりません。
                    </div>
                </div>

                <div id="lang_his" class="container tab-pane active p-0">
                    <!-- 検索履歴 -->
                    <lang-his-list 
                        ref="list"
                        :has-header="false"
                        mt
                        :mg="false"
                        >
                        <div v-if="getListObj">
                            <div v-if="getListObj.data.length > 0">
                                <div class="card mb-2 px-2">
                                    <ul class="list-group list-group-flush">
                                        <li v-for="item in getListObj.data" :key="item.id" class="list-group-item p-0 let-space-1">
                                            <div class="d-flex align-items-center">
                                                <span>
                                                    <b> {{item.free_word}} </b>
                                                </span>
                                                <span class="flex-fill text-right">
                                                    <small> {{item.name}} </small>
                                                    <small> /{{item.user_group}} </small>
                                                    <small v-if="item.cmp_group"> /{{item.cmp_group}} </small>
                                                </span>
                                            </div>
                                            <div class="text-left">
                                                <small>{{item.created_at | dformatm}}</small>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </lang-his-list>
                </div>

                <div id="lang_total" class="container tab-pane fade p-0">
                    <!-- 検索頻度 -->
                    <div v-if="getListObj && getListObj.free_word">
                        <div v-if="getListObj.free_word.length > 0">
                            <li v-for="(item,idx) in getListObj.free_word" :key="idx" class="list-group-item p-1 let-space-1">
                                <div class="d-flex align-items-center">
                                    <span>
                                        ({{item.word_cnt}}/{{getListObj.total_word_cnt}}/{{Math.round(item.word_cnt/getListObj.total_word_cnt*100)}}%)　<b>{{item.free_word}}</b> 
                                    </span>
                                </div>
                                <div class="progress-bar" role="progressbar" :style="{width:Math.round(item.word_cnt/getListObj.total_word_cnt*100) + '%'}" 
                                    :aria-valuenow="Math.round(item.word_cnt/getListObj.total_word_cnt*100)" aria-valuemin="0" aria-valuemax="100">
                                    {{Math.round(item.word_cnt/getListObj.total_word_cnt*100)}}%
                                </div>
                            </li>
                        </div>
                        <div v-else class="py-5 text-center text-muted">
                            <i class="fas fa-search h1"></i><br>
                            データが見つかりません。
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Header from 'pages/commons/header/Header'
import LangHisList from 'pages/commons/List/List'
import {mapGetters} from 'vuex'

export default {
    components:{
        Header,
        LangHisList
    },
    mounted() {
        this.loadLangGraph()
        this.loadListObj()
    },
    watch: {
        getCmpLangGraphLoadStatus (status) {
            if (status == 1) {
                this.$store.dispatch('startProgress')
            }
            if (status == 2) {
                this.getCmpLangGraph.lang_data.sort((a,b)=>b.lang_cnt - a.lang_cnt)
                this.$store.dispatch('doneProgress')
            }
            if (status == 3) {
                this.$store.dispatch('doneProgress')
            }
        },
    },
    computed: {
        langList () {
            return this.getCmpLangGraph.lang_data || []
        },
        ...mapGetters(['getListObj', 'getCmpLangGraph', 'getCmpLangGraphLoadStatus'])
    },
    methods:{
        loadLangGraph () {
            this.$store.dispatch('loadLangGraph')
        },
        loadListObj () {
            this.$refs.list.loadListObj({ 
                url:'cmp.lang.his',
                data: '0'
            })
        },
        seeMoreMt () {
            this.$store.dispatch('loadListObjSeeMore', {
                url:'cmp.lang.his',
                skip: this.getListObj.data.slice(-1)[0].id
            })
        },
    }
}

</script>


<style>

</style>
